'use client';

import { HttpContextProvider, HttpContextProviderProps } from '@grupa-pracuj/http-client-relax/dist/context';

export function HttpClientContextProvider({ children, config }: HttpContextProviderProps) {
  return <HttpContextProvider config={config}>{children}</HttpContextProvider>;
}
